import { useEffect,  useState } from 'react'
import { gql,ApolloCache, FetchResult, useApolloClient, useLazyQuery, useMutation } from "@apollo/client";
import { Modal, ModalHeader, ModalBody, ModalFooter, Alert } from 'reactstrap';
import { MOVE_ORG,IS_CHILD, GET_ORG_RELATIONSHIPS, GET_CATEGORIES, GET_CHILD_ORGS, GET_ORG_DETAILS, GET_ROOT_ORGS} from '../../../../graphql/org-gql';
import { ICategory, IChildOrgsResponse, IOrg, IOrgRelationship, IRootOrgsResponse, isCategory } from '../../../../types/org';
import OrgTree from '../../../common/org-tree/org-tree';
import { messages } from '../../../../i18n/message';
import { LOCALES } from '../../../../i18n/locales';
import { CancelIcon, MoveIcon } from '../../../common/icons';
import MessageModal from '../../../common/message-modal';
import useOrgTypes from '../../../../hook/useOrgTypes';
import { UserRoleType } from '../../../../types/constants';
import AuthWrapper from '../../../common/auth-wrapper';
import { notifyError, notifySuccess } from '../../../../services/notification';
import '../../org.scss';
import useAuth from '../../../../hook/useAuth';
import useScope from '../../../../hook/useScope';
import SpinnerOverlay from '../../../common/spinner/spinner';
import { Action } from '../../../../types/individual';
import Button from '../../../common/button';
import Select from '../../../common/select/select';

type OrgMoveProps = {
    parentOrg: ICategory | IOrg,
    relationships: IOrgRelationship[],
    isOpen: boolean,
    toggle: () => void
}

const RelationshipMoveModal = (props: OrgMoveProps) => {
    const { parentOrg, relationships, isOpen, toggle } = props
    const { isAdmin,isCoordinator } = useAuth();
    const destIds = relationships?.map(rel=>rel.destOrgId);
    const destParentOrgIds = relationships?.map(rel=>rel.destParentOrgId);
    const [movetoOrg, setMovetoOrg] = useState<ICategory | IOrg>();
    const [orgTypeId,setOrgTypeId] = useState<string>('');
    const [msg,setMsg] =  useState<string>('');
    const [messageModal, setMessageModal] = useState(false);
    const locale = LOCALES.ENGLISH;
    const [getOrgDetails,{loading:getOrgLoading}] = useLazyQuery(GET_ORG_DETAILS)
    //const [getOrgCategory] = useLazyQuery(GET_ORG_CATEGORY)
    const [moveOrgs,{loading:moveOrgLoading}] = useMutation(MOVE_ORG)
    const client = useApolloClient()
    const { categories } = client.readQuery({query: GET_CATEGORIES})
    const { orgTypes } = useOrgTypes(movetoOrg)
    const isScope = useScope(movetoOrg?.id||0,false)
    const [parentOrgDetail,setParentOrgDetail] =  useState<IOrg>();
    const [getRootOrgs, {loading: rootLoading}] = useLazyQuery<IRootOrgsResponse>(GET_ROOT_ORGS,{fetchPolicy: 'network-only'})
    const [getChildOrgs, {loading: childLoading}] = useLazyQuery<IChildOrgsResponse>(GET_CHILD_ORGS,{fetchPolicy: 'network-only'})
    const [isChild,{loading:isChildLoading,data:isMovetoChild}]=useLazyQuery(IS_CHILD)

    useEffect(()=>{
        parentOrg &&
            getOrgDetails({variables:{id:parentOrg.id}}).then(response=>{
                response.data?.org && setParentOrgDetail(response.data.org)
            })

    },[parentOrg])

    useEffect(() => {
        //console.log("movetoOrg:",movetoOrg);
        (destIds.includes(movetoOrg?.id||0)) && setMsg(messages[locale].ERROR['5044']);
        (movetoOrg && (( isCategory(movetoOrg) && isCoordinator && !isAdmin) ||(isCoordinator && !isAdmin && !isScope ))) &&
            setMsg(messages[locale].ERROR['5041']);
        (destParentOrgIds.includes(movetoOrg?.id||0)) && setMsg(messages[locale].ERROR['5043']);
        (movetoOrg && (!isCategory(movetoOrg) && !!movetoOrg?.details?.shareLinkId)) &&
            setMsg(messages[locale].ERROR['5042']);
        return ()=>{setMsg('');}
    }, [movetoOrg]);

    useEffect(()=>{
        if(!isCategory(movetoOrg) && orgTypes && movetoOrg?.parentOrg!==null && movetoOrg?.details?.category.categoryName==='Ministries, Secretariats and Offices'){
            const targetOrgType = movetoOrg.details.orgType
            const index = orgTypes.findIndex(item=>item.id===targetOrgType.id)
            //console.log("index:",index)
            if(orgTypes.length>index+1 ){
                setOrgTypeId(orgTypes[index+1]?.id?.toString())
            }
        }else{
            setOrgTypeId('');
        }

    },[orgTypes,movetoOrg])

    useEffect(() => {
        isMovetoChild?.isChild && setMsg(messages[locale].ERROR['5045']);
        return ()=>{setMsg('');}
    },[isMovetoChild,locale]);

    useEffect(()=>{
        msg && setMessageModal(true)
    },[msg])

    const selectOrg = async (org?: ICategory | IOrg) => {
        if(org){
            setMsg('');
            //console.log("org:",org)
            if(!isCategory(org)){
                const orgResponse = await getOrgDetails({variables:{id:org?.id}})
                orgResponse.data.org && setMovetoOrg(orgResponse.data.org);
                (orgResponse.data.org && !isCategory(orgResponse.data.org) && !orgResponse.data.org.details?.shareLinkId && !destIds.includes(org.id||0) && (!destParentOrgIds.includes(org.id||0)))
                    && isChild({variables:{parentIds:destIds,childId:org.id}})
            }else{
                setMovetoOrg(org)
            }

        }
    }

    const onMoveOrgs = () => {
        moveOrgs({
            variables: {
                action: Action.MOVE_RELATIONSHIP_VALIDATION,
                orgId: movetoOrg?.id,
                input: {orgId: movetoOrg?.id,childOrgIds: destIds,relTypeId: orgTypeId,parentCategory: isCategory(movetoOrg)}
            },        
            onCompleted: (data) => {
                if(data?.moveOrgs?.success){
                    moveOrgs({
                        variables: {
                            action: Action.MOVE_RELATIONSHIP,
                            orgId: movetoOrg?.id,
                            input: {orgId: movetoOrg?.id,childOrgIds: destIds,relTypeId: orgTypeId,parentCategory: isCategory(movetoOrg)}
                        },
                        refetchQueries: getRefetchQuery(),
                        awaitRefetchQueries: true,
                        update(cache,{data}){updateCache(cache,data,destIds,parentOrg,movetoOrg)},
                        onCompleted: (data) => {
                            toggle()
                            data && notifySuccess()
                        }
                    })
                    

                }else if(data?.moveOrgs.message){
                    notifyError(data.moveOrgs.message)
                }                  
            }
        })
        setOrgTypeId('');
        setMovetoOrg(undefined);
        
    }

    const updateCache = (cache : ApolloCache <any>, result: any,destIds:number[],parentOrg:ICategory|IOrg,movetoOrg:ICategory|IOrg|undefined) => {
        
        //remove orgPath
        cache.evict({ id: 'ROOT_QUERY', fieldName: 'orgPath' });
        cache.gc();
       
        // update hasChild for toOrg
        cache.modify({
            id: `Org:${movetoOrg?.id}`,
            fields: {
                hasChild() {
                    return true;
                }
            }
        })

        //update parent org children
        const cachedFromChildren = cache.readQuery<{childOrgs:IOrg[]}>({
            query:GET_CHILD_ORGS,
            variables:{id:parentOrg.id}
        })?.childOrgs;
        const updatedFromChildren = cachedFromChildren?.filter(child=>!destIds.includes(child.id))      
        cache.writeQuery({
            query:GET_CHILD_ORGS,
            variables:{id:parentOrg.id},
            data:{
                childOrgs:updatedFromChildren
            }
        })
        //update parent org hasChild
        if(!updatedFromChildren||updatedFromChildren.length===0){
            cache.modify({
                id: `Org:${parentOrg.id}`,
                fields: {
                    hasChild() {
                        return false;
                    }
                }
            })
        }
        //console.log("cachedMoveChildren:",cachedMoveChildren)   

        if(isCategory(movetoOrg)){
            getRootOrgs({variables:{ categoryId: movetoOrg.id}})

        }else{
            //update to Org children
            getChildOrgs({variables:{id:movetoOrg?.id}})
        } 
    }

    const getRefetchQuery = () => {
        return [{query: GET_ORG_RELATIONSHIPS, variables: { orgId: parentOrg.id }},
            {query: GET_ORG_RELATIONSHIPS, variables: { orgId: movetoOrg?.id }}];
        /*const refetchQuery1 = [{query: GET_ORG_RELATIONSHIPS, variables: { orgId: parentOrg.id }},
            {query: GET_ORG_RELATIONSHIPS, variables: { orgId: movetoOrg?.id }},
            {query: GET_CHILD_ORGS,variables: { id: parentOrg.id}},
            {query: GET_CHILD_ORGS,variables: { id: movetoOrg?.id}}];
        const refetchQuery2 = [
            {query: GET_ROOT_ORGS, variables: { categoryId: movetoOrg?.id }}];
        const refetchQuery3 = [
            {query: GET_ROOT_ORGS, variables: { categoryId: parentOrgDetail?.details.category.id }}];

        if(isCategory(movetoOrg) && (parentOrgDetail && parentOrgDetail.parentOrg)){
            console.log([...refetchQuery1,...refetchQuery2,...refetchQuery3])
            return [...refetchQuery1,...refetchQuery2,...refetchQuery3]
        }else if(isCategory(movetoOrg)){
            console.log([...refetchQuery1,...refetchQuery2])
            return [...refetchQuery1,...refetchQuery2]
        }else{
            console.log([...refetchQuery1])
            return refetchQuery1
        }*/

    }

    const changeOrgType = (event: any) => {
        setOrgTypeId(event.target.value);
    }

    const onCancel=()=>{
        setMovetoOrg(undefined);
        setOrgTypeId('');
        toggle();
    }
    const messageToggle = ()=>{
        setMessageModal(!messageModal)
        //setMsg('');
    }
    return (
    <>
        {(moveOrgLoading || rootLoading||childLoading||isChildLoading||getOrgLoading) && <SpinnerOverlay/>}
        {/*messageModal && <MessageModal isOpen={messageModal} titleText='Warning!' toggle={messageToggle}>{msg}</MessageModal>*/}
        {<Modal size="lg" isOpen={isOpen} toggle={onCancel} backdrop="static" scrollable={true}>
            <ModalHeader toggle={onCancel}>Move Selected Related Organizations</ModalHeader>
            <ModalBody>
                { msg && <Alert color="danger" style={{margin:'0px'}}> {msg}</Alert> }
                <div>Please select which organization you would like to move the selected related organization to.</div>
                <div className="row" style={{maxHeight:'350px',overflowY:"auto",border: '1px solid var(--bs-border-color-translucent)',margin:'1px',padding:'5px'}}>
                    <OrgTree roots={categories || []} isGlobal={false} onSelected={selectOrg}></OrgTree>
                </div>

                <div className="row">
                    <div className="col-md-4"><label htmlFor="orgType" id="orgtype-label">Move as Type:</label></div>
                    <div className="col-md-8">
                    <Select id="orgType" aria-labelledby="orgtype-label" value={orgTypeId || ''} disabled={movetoOrg == undefined}
                        onChange={changeOrgType} style={{width:'100%'}} required>
                        <option key={0} value="" disabled hidden aria-label="select">Select a type to move as...</option>
                        {orgTypes?.map(item =>
                            <option key={item.id} value={item.id} aria-label={item.label}>
                                {item.label}
                            </option>)}
                    </Select>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <AuthWrapper role={[UserRoleType.ADMINISTRATOR,UserRoleType.COORDINATOR]}>
                    {(authorized:boolean)=>
                        <Button color="primary" disabled={(movetoOrg&&orgTypeId&&!msg&&authorized)?false:true} onClick={onMoveOrgs} >
                            <MoveIcon/>
                            Move
                        </Button>
                    }
                </AuthWrapper>

                <Button color="secondary" onClick={onCancel}>
                    <CancelIcon/>
                    Cancel
                </Button>
            </ModalFooter>
        </Modal>}
    </>
    )
}

export default RelationshipMoveModal;
